<template>
  <div>
    <Prompt v-if="isPopDialogShown" :is-shown.sync="isPopDialogShown">
      <div class="title">温馨提示</div>
      <template v-slot:content>
        <div class="title">温馨提示</div>
        <p class="description" >{{popDialogMsg}}
        </p>
      </template>
      <template v-slot:button>
        <div class="tips-btn-t" v-if="showInitButton" @click="goMyTeam">确定</div>
      </template>
    </Prompt>

    <!-- 创建我的战队 -->
    <div class="index-create" v-if="period==peroidEnums.FORMATION" @click="createTeam">
      <p>创建我的小队<i></i></p>
    </div>

    <div class="team-end" v-if="period!=peroidEnums.FORMATION && isNotInTeam">
      <img src="~2021team-pk-ui/assets/team-end-icon.png" alt=""> 很可惜，活动组队期已结束
    </div>

    <!-- 组队 -->
    <div class="index index-team" v-if="period==peroidEnums.FORMATION && strangerTeam">
      <div class="caption">
        <img class="caption-l" src="~2021team-pk-ui/assets/index-title-icon-l.png" alt="">
        加入其他小队
        <img class="caption-r" src="~2021team-pk-ui/assets/index-title-icon-r.png" alt="">
      </div>
      <div class="refresh" @click="refreshStrangerTeam">
        <img :class="[isStrangerRefreshing? 'spin-style' : '']" src="~2021team-pk-ui/assets/refresh.png" alt="">刷新
      </div>
      <div class="join-con">
        <div class="join-bar"></div>
        <div class="join-con-scroll">
          <div class="join-con-item" v-for="(team) in strangerTeam" :key="team.team_id">
            <img :src="getMember(team.leader_nick_img).avatar" alt="" />
            <div class="info">
              <p>{{ getMember(team.leader_nick_img).nickName }}</p>
              <span>{{ team.team_members_number }}/{{ maxTeamMember }}</span>
            </div>
            <div class="btn" @click="join(team.team_id)">申请加入</div>
          </div>
        </div>
      </div>
    </div>


    <Prompt v-if="isQueueShown" :is-shown.sync="isQueueShown" is-close-hidden="true">
      <template v-slot:content>
        <div class="title">温馨提示</div>
        <p class="description" style="text-align: center">哎呀，活动太火爆啦，正在排队进入……
          <span>{{ retryCountDown > 0 ? retryCountDown : "" }}</span>
        </p>
      </template>
      <template v-slot:button>
        <div class="tips-btn-t" v-if="isRetryBtnShown" @click="retry">重试</div>
      </template>
    </Prompt>

    <!-- <Prompt v-if="isActivityEnd" class="end" :is-shown="isActivityEnd" is-close-hidden="true">
      <template v-slot:content>
        <div class="title">活动已结束</div>
        <p class="description">您可以关注“腾讯充值”公众号，后续活动将会通过公众号通知您～</p>
      </template>
    </Prompt> -->

<!--    <Prompt v-if="isInBrowserShown" :is-shown.sync="isInBrowserShown" is-close-hidden="true">-->
<!--      <template v-slot:content>-->
<!--        <div class="title">温馨提示</div>-->
<!--        <p class="description">请在微信或手Q内打开本次活动</p>-->
<!--      </template>-->
<!--      <template v-slot:button>-->
<!--        <div class="tips-btn-t" @click="goWechatOpenlink">微信</div>-->
<!--        <div class="tips-btn-t" @click="goQQ">QQ</div>-->
<!--      </template>-->
<!--    </Prompt>-->
    <Toast :toast-msg="toastMsg"></Toast>
  </div>

</template>

<script>
import { mapActions, mapGetters, mapState } from "vuex"
import PopDialog from "./components/PopDialog.vue"
import Prompt from "./components/Prompt.vue"
import * as config from "./config"
import Toast from "./components/Toast.vue"
import { getStrParams } from "../bargain/utils/url"
import { UTC8TimeToTimeStamp } from "../bargain/utils/helper"

export default {
  name: "Index",
  components: { PopDialog, Prompt, Toast },
  mounted() {
    this.setOnShareHandler({ page: "index" })
  },
  beforeRouteEnter(to, from, next) {
    next(vm => {
      vm.init()
    })
  },
  data() {
    return {
      isPopDialogShown: false,
      popDialogMsg: "",
      strangerTeam: "",
      maxTeamMember: config.GAME_INFO.maxJoinQuantity,
      peroidEnums: config.PEROID,
      period: "",
      coupon: "",
      individualCoupon: "",
      isQueueShown: false,
      isRetryBtnShown: false,
      retryCountDown: 10,
      isActivityEnd: false,
      isInBrowserShown: false,
      isNotInTeam: false,
      isStrangerRefreshing: false,
      showInitButton: false,
      toastMsg: ""
    }
  },
  computed: {
    ...mapState(["selectedZone", "selectedRole", "userAgent", "pf", "gameInfo"]),
    ...mapGetters(["loginState", "now"])
  },
  methods: {
    ...mapActions([
      "getLoginState",
      "createTeamProc",
      "setTeamCreatedDialogShown",
      "setShareTeamId",
      "getTeamDetail",
      "getStrangerTeam",
      "joinTeam",
      "getActivity",
      "setOnShareHandler",
      "setJackPot",
      "reportUserAction",
      "getTotalParticipant",
      "jumpToMqq",
      "subscribeActivity",
      "setIndividualJackpot"
    ]),
    init() {
      this.getActivity().then(res => {
        let ruleItem = res.filter(rule => rule.period == config.PEROID.PK)[0]
        let now = this.now
        if (ruleItem) {
          this.coupon = ruleItem.present_item
          this.individualCoupon = ruleItem.individual_present_type
        }
        if (now > UTC8TimeToTimeStamp(ruleItem.end_time)) {
          // 活动结束
          this.period = this.peroidEnums.END
          this.isActivityEnd = true
        } else {
          res.forEach(act => {
            if (now <= UTC8TimeToTimeStamp(act.end_time) && now >= UTC8TimeToTimeStamp(act.begin_time)) {
              this.period = act.period
            }
          })
          this.getLoginState()
            .then(() => {
              this.getTotalParticipant()
              return this.getTeamDetail({})
            })
            .then(res => {
              let teamid = res.info.team_info.team_id
              if (teamid) {
                this.$router.replace(`/team/${teamid}`)
              } else {
                this.isNotInTeam = true
                this.$parent.isInTeam = false
                this.reportUserAction({
                  iformat: config.REPORT.PAGEVIEW.NEW_USER
                })
                if (this.period == this.peroidEnums.FORMATION) {
                  this.queryStrangerTeam()
                }
                this.setJackPot(this.coupon)
                this.setIndividualJackpot(this.individualCoupon)
              }
            })
            .catch(res => {
              if (res.ret == 1414) {
                this.period = this.peroidEnums.END
                this.isActivityEnd = true
              } else if (res == "无登陆态") {
                return
              } else {
                this.queue(res)
              }
            })
        }
      })
    },
    queue(res) {
      this.isQueueShown = true
      this.isRetryBtnShown = false
      this.retryCountDown = 10
      clearInterval(this.queueTimer)
      let queueTimer = setInterval(() => {
        this.retryCountDown--
        if (this.retryCountDown == 0) {
          this.isRetryBtnShown = true
          clearInterval(queueTimer)
        }
      }, 1000)
      this.reportUserAction({
        iformat: config.REPORT.PAGEVIEW.INDEX_QUEUE,
        resultInfo: res
      })
    },
    retry() {
      this.isQueueShown = false
      this.init()
    },
    handleError(res) {
      if (res.ret == 1414) {
        this.period = this.peroidEnums.END
      } else if (res.multi_err == "1132-2007001-0") {
        this.isPopDialogShown = true
        this.popDialogMsg = res.msg
        this.showInitButton = true
      } else {
        this.isPopDialogShown = true
        let msg = `系统繁忙，请稍后再试！(${res.ret})`
        if (res && res.msg && res.err_code == "") {
          msg = res.msg
        }
        this.popDialogMsg = msg
      }
    },
    goMyTeam() {
      this.init()
      this.showInitButton = false
    },
    createTeam() {
      this.reportUserAction({
        iformat: config.REPORT.CLICK.CREATE_TEAM
      })
      this.createTeamProc()
        .then(res => {
          //5de76929-1e9a-894a-3de5-3824f2ebf2c7
          this.reportUserAction({
            iformat: config.REPORT.PAGEVIEW.TEAM_CREATE_SUCCESS_DIALOG
          })
          let teamid = res.info.team_id
          this.maskHeight = document.documentElement.scrollHeight
          this.$router.push(`/team/${teamid}`)
          this.setTeamCreatedDialogShown(true)
          this.setShareTeamId(teamid)
          //   this.subscribeActivity("subscribe")
        })
        .catch(res => {
          this.reportUserAction({
            iformat: config.REPORT.PAGEVIEW.CREATE_TEAM_ERROR,
            resultInfo: res
          })
          this.handleError(res)
        })
    },
    queryStrangerTeam() {
      if (this.gameInfo.queryStrangerTeam) {
        // 防止用户快速点击
        if (this.isStrangerRefreshing) return
        this.isStrangerRefreshing = true
        this.getStrangerTeam()
          .then(res => {
            if (res.info.strange_team_info && res.info.strange_team_info.length > 0) {
              this.strangerTeam = res.info.strange_team_info
            } else {
              this.strangerTeam = ""
            }
          })
          .catch(res => {
            this.reportUserAction({
              iformat: config.REPORT.PAGEVIEW.STRANGER_TEAM_ERROR,
              resultInfo: res
            })
            if (this.isStrangerRefreshing) {
              this.toastMsg = "查询异常，请刷新重试！"
              setTimeout(() => {
                this.toastMsg = ""
              }, 2000)
            }
          })
          .then(() => {
            this.isStrangerRefreshing = false
          })
      }
    },
    refreshStrangerTeam() {
      this.strangerTeam = []
      this.queryStrangerTeam()
    },
    join(team_id) {
      this.reportUserAction({
        iformat: config.REPORT.CLICK.JOIN_STRANGER_TEAM
      })
      this.joinTeam({ team_id })
        .then(() => {
          this.isPopDialogShown = true
          this.popDialogMsg = "申请已发送～"
        })
        .catch(res => {
          this.reportUserAction({
            iformat: config.REPORT.PAGEVIEW.JOIN_TEAM_ERROR,
            resultInfo: res
          })
          this.handleError(res)
        })
    },
    goBuy() {
      this.reportUserAction({
        iformat: config.REPORT.CLICK.BUY_GAMECOIN
      })
      if (this.userAgent.android && (this.userAgent.QQ || this.userAgent.weixin)) {
        location.href = `https://pay.qq.com/h5/shop.shtml?pf=${this.pf}#/order/2/biz/2?serviceZone=1`
      } else {
        this.isPopDialogShown = true
        this.popDialogMsg = "请前往游戏充值点券"
      }
    },
    goWechatOpenlink() {
      location.href = this.gameInfo.openlink
    },
    goQQ() {
      this.jumpToMqq(location.href)
    },
    /**
     * 获取团员的头像昵称
     */
    getMember(str) {
      let obj = getStrParams(decodeURIComponent(str), true)
      let nickName = "腾讯用户"
      if (obj?.nick_name) {
        try {
          nickName = decodeURIComponent(obj.nick_name)
        } catch (error) {
          nickName = obj.nick_name
        }
      }
      let avatar = obj.img_url || this.gameInfo.defaultAvatar
      return {
        avatar,
        nickName
      }
    }
  }
}
</script>

<style scoped>
</style>
